import React, { createContext, useContext, useMemo } from 'react'
import { useAuth } from '@context/AuthContext/AuthContext'
import { useSkillsData } from '@hooks/useSkillsData'
import { SkillsContextProps, SkillsContextDefaultValues } from '@Interfaces/Data/SkillInterface'
import { ContextComponentProps } from '@Interfaces/Util/CommonInterface'

export const SkillsContext = createContext<SkillsContextProps>(SkillsContextDefaultValues)

export const SkillsProvider = ({ children }: ContextComponentProps) => {
  const { currentUser } = useAuth()
  const { allSkills, setAllSkills, ourSkills, setOurSkills } = useSkillsData(currentUser)

  const contextValue = useMemo(
    () => ({
      allSkills,
      setAllSkills,
      ourSkills,
      setOurSkills,
    }),
    [allSkills, ourSkills]
  )

  return <SkillsContext.Provider value={contextValue}>{children}</SkillsContext.Provider>
}

export const useSkills = (): SkillsContextProps => useContext(SkillsContext)
